document.addEventListener("click", e => {
    const btn = e.target.closest(".tap-shop-btn");

    if (btn) {
        const slide = btn.closest(".look-slide");

        document.getElementById("popup-look-description").innerHTML =
            slide.dataset.description;

        document.getElementById("popup-look-image").src =
            slide.dataset.image;

        document.getElementById("popup-look-products").innerHTML =
            slide.querySelector(".look-products-template").innerHTML;

        initShopLook();

        document.getElementById("shop-look-modal").classList.add("is-open");
        document.body.classList.add("overflow-hidden");

        return;
    }

    if (
        e.target.closest(".close-look") ||
        e.target.classList.contains("shop-look-overlay")
    ) {
        document.getElementById("shop-look-modal").classList.remove("is-open");
        document.body.classList.remove("overflow-hidden");
    }
});

function ordinal(day) {
    if (day > 3 && day < 21) return `${day}th`;

    return `${day}${
        { 1: "st", 2: "nd", 3: "rd" }[day % 10] || "th"
    }`;
}

function formatDate(offset) {
    const d = new Date();
    d.setDate(d.getDate() + Number(offset));

    return `${ordinal(d.getDate())} ${d.toLocaleString("en-US", {
        month: "short"
    })}`;
}

/* ============================================================
 * KALLES PREORDER CART PROPERTIES
 * ============================================================ */

(function () {
    const PREORDER_STATUS = "MADE-TO-ORDER";

    function buildPreorderProperties({
        isPreorder = false,
        start = 0,
        end = 0,
        status = PREORDER_STATUS
    } = {}) {
        if (!isPreorder) return {};

        start = Number(start || 0);
        end = Number(end || 0);

        return {
            "_preorder_status": status,
            "_shipping_from":
                start && end
                    ? `${formatDate(start)} - ${formatDate(end)}`
                    : ""
        };
    }

    function getPreorderPropertiesFromOption(option) {
        if (!option) return {};

        const {
            inventoryquantity = 0,
            inventorypolicy = "",
            start = 0,
            end = 0
        } = option.dataset;

        return buildPreorderProperties({
            isPreorder:
                Number(inventoryquantity) <= 0 &&
                inventorypolicy === "continue",
            start,
            end
        });
    }

    function removePreorderInputs(form) {
        form?.querySelectorAll(
            'input[data-kalles-preorder-property="true"]'
        ).forEach(input => input.remove());
    }

    function updateProductPreorderProperties(form) {
        if (!form) return;

        const select = form.querySelector('select[name="id"]');
        const input = form.querySelector('input[name="id"]');
        const option =
            select?.selectedOptions?.[0] ||
            input;

        removePreorderInputs(form);

        if (!option) return;

        const properties =
            getPreorderPropertiesFromOption(option);

        if (
            !properties._preorder_status &&
            !properties._shipping_from
        ) {
            return;
        }

        Object.entries(properties).forEach(([name, value]) => {
            const el = document.createElement("input");

            el.type = "hidden";
            el.name = `properties[${name}]`;
            el.value = value;
            el.dataset.kallesPreorderProperty = "true";

            form.appendChild(el);
        });
    }

    window.KallesPreorder = {
        buildPreorderProperties,
        getPreorderPropertiesFromOption,
        updateProductPreorderProperties
    };

    function initProductPreorderForms() {
        document
            .querySelectorAll('form[data-type="add-to-cart-form"]')
            .forEach(form => {
                updateProductPreorderProperties(form);

                const select = form.querySelector('select[name="id"]');

                select?.addEventListener("change", () =>
                    updateProductPreorderProperties(form)
                );
            });
    }

    document.addEventListener("variant:change", e => {
        const form =
            e.target?.closest?.(
                'form[data-type="add-to-cart-form"]'
            ) ||
            document.querySelector(
                'form[data-type="add-to-cart-form"]'
            );

        if (form) {
            updateProductPreorderProperties(form);
        }
    });

    if (document.readyState === "loading") {
        document.addEventListener(
            "DOMContentLoaded",
            initProductPreorderForms
        );
    } else {
        initProductPreorderForms();
    }
})();

function formatShopLookMoney(cents) {
    cents = Number(cents || 0);

    const currency =
        window.Shopify?.currency?.active ||
        window.Shopify?.currency?.default ||
        "USD";

    let format = window.Shopify?.money_format;

    if (
        window.Shopify?.currency?.active &&
        window.Shopify.currency.active !==
            window.Shopify.currency.default
    ) {
        format =
            window.Shopify.currency.active_format ||
            format;
    }

    if (
        typeof window.Shopify?.formatMoney === "function" &&
        format
    ) {
        return window.Shopify.formatMoney(cents, format);
    }

    try {
        return new Intl.NumberFormat(
            document.documentElement.lang || "en-US",
            {
                style: "currency",
                currency
            }
        ).format(cents / 100);
    } catch {
        return (cents / 100).toFixed(0);
    }
}

function initShopLook() {
    document.querySelectorAll(".shop-look-form").forEach(form => {
        if (form.dataset.loaded) return;

        form.dataset.loaded = "1";

        const variantsJson =
            form.querySelector(".variants-json");

        const variantExtraJson =
            form.querySelector('[id^="variant-extra-"]');

        if (!variantsJson || !variantExtraJson) {
            console.error(
                "[Shop The Look] Variant JSON missing",
                { form, variantsJson, variantExtraJson }
            );
            return;
        }

        const variants =
            JSON.parse(variantsJson.textContent.trim());

        const variantExtra =
            JSON.parse(variantExtraJson.textContent.trim());

        const wrapper =
            form.closest(".t4s-space-item-inner");

        if (!wrapper) return;

        const image =
            wrapper.querySelector(".shop-look-product-image");

        const imageLink =
            wrapper.querySelector(".shop-look-image-link");

        const defaultImage =
            form.dataset.defaultImage;

        const selects =
            form.querySelectorAll(".variant-option");

        const input =
            form.querySelector(".variant-id");

        const customizeWrapper =
            form.querySelector(".customize-properties");

        function updateVariantPrice(variant) {
            const priceWrapper =
                wrapper.querySelector(
                    "[data-complete-look-price]"
                );

            if (!priceWrapper || !variant) return;

            const price = Number(variant.price || 0);
            const compareAtPrice =
                Number(variant.compare_at_price || 0);

            const hasSale =
                compareAtPrice > price;

            const rates =
                window.bucksCC?.Currency?.rates;

            const currency =
                document
                    .querySelector(".bucks-selected")
                    ?.textContent
                    ?.trim()
                    ?.toUpperCase() ||
                "USD";

            const convertPrice = cents => {
                const amount = Number(cents || 0) / 100;

                if (
                    !rates?.USD ||
                    !rates[currency]
                ) {
                    return amount;
                }

                return (
                    amount *
                    rates.USD /
                    rates[currency]
                );
            };

            const formatMoney = cents =>
                `${new Intl.NumberFormat("vi-VN", {
                    maximumFractionDigits: 0
                }).format(convertPrice(cents))} ${currency}`;

            priceWrapper.querySelector(
                "[data-complete-look-price-value]"
            )?.replaceChildren(
                document.createTextNode(formatMoney(price))
            );

            const compareElement =
                priceWrapper.querySelector(
                    "[data-complete-look-compare-price]"
                );

            if (compareElement) {
                compareElement.textContent =
                    hasSale
                        ? formatMoney(compareAtPrice)
                        : "";
            }

            const compareWrapper =
                priceWrapper.querySelector(
                    "[data-complete-look-compare-wrapper]"
                );

            if (compareWrapper) {
                compareWrapper.style.display =
                    hasSale ? "" : "none";
            }
        }

        function toggleCustomizeForm() {
            if (!customizeWrapper || !selects.length) return;

            let sizeSelect;

            selects.forEach(select => {
                const optionName =
                    select
                        .closest(".variant-group")
                        ?.querySelector("label")
                        ?.textContent
                        ?.trim()
                        ?.toLowerCase();

                if (optionName === "size") {
                    sizeSelect = select;
                }
            });

            sizeSelect ||= selects[0];

            customizeWrapper.style.display =
                sizeSelect.value
                    .trim()
                    .toLowerCase() === "customize"
                    ? ""
                    : "none";
        }

        function updateVariant() {
            const values =
                [...selects].map(select => select.value);

            const variant = variants.find(v =>
                values.every(
                    (value, index) =>
                        String(v.options[index]).trim() ===
                        String(value).trim()
                )
            );

            if (!variant) {
                console.warn(
                    "[Complete Look] Variant not found",
                    {
                        productId: form.dataset.productId,
                        values,
                        variants
                    }
                );
                return;
            }

            updateVariantPrice(variant);

            if (input) {
                input.value = variant.id;
            }

            const btn =
                form.querySelector(".shop-look-btn");

            if (btn) {
                btn.dataset.variantId = variant.id;
            }

            form.dataset.currentVariantId = variant.id;

            toggleCustomizeForm();


            /* PREORDER */

            const preorder =
                wrapper.querySelector(".shop-look-preorder");

            const meta =
                variantExtra[variant.id];

            if (preorder && meta) {
                const btnText =
                    form.querySelector(".btn-text");

                if (meta.isPreorder) {
                    if (btnText) {
                        btnText.textContent = "MADE-TO-ORDER";
                    }

                    preorder.style.display = "";

                    preorder.innerHTML = `
                        <div class="preorder-shipping">
                            MADE-TO-ORDER
                            <svg viewBox="0 0 15 15" fill="none">
                                <path
                                    d="M6.25501 7.69L6.31801 7.5L6.25501 7.31L5.76801 5.849L8.51901 7.5L5.76801 9.151L6.25501 7.69Z"
                                    fill="currentColor"
                                />
                            </svg>
                            Shipping from
                            <strong>
                                ${formatDate(meta.dispatchStart)}
                                -
                                ${formatDate(meta.dispatchEnd)}
                            </strong>
                        </div>
                    `;
                } else {
                    if (btnText) {
                        btnText.textContent = "Add to cart";
                    }

                    preorder.style.display = "none";
                    preorder.innerHTML = "";
                }
            }

            /* IMAGE */
            let src =
                variant?.featured_media?.preview_image?.src ||
                variant?.featured_image?.src ||
                defaultImage;

            if (!src) return;

            if (src.startsWith("//")) {
                src = "https:" + src;
            }

            if (!src.includes("width=")) {
                src +=
                    src.includes("?")
                        ? "&width=700"
                        : "?width=700";
            }

            if (image) {
                image.src = src;
                image.dataset.src = src;
                image.removeAttribute("srcset");
            }

            if (imageLink) {
                imageLink.style.backgroundImage =
                    `url("${src}")`;
            }
        }

        selects.forEach(select =>
            select.addEventListener("change", updateVariant)
        );

        updateVariant();
    });
}

document.addEventListener("DOMContentLoaded", initShopLook);

document.addEventListener("click", async e => {
    const btn =
        e.target.closest("[data-complete-look-add]");

    if (!btn || btn.disabled) return;

    const form =
        btn.closest(".shop-look-form");

    if (!form) return;

    const variantId =
        form.querySelector(".variant-id")?.value;

    if (!variantId) {
        console.error(
            "[Complete the look] Missing variant ID"
        );
        return;
    }

    /* COMPLETE THE LOOK DATA */

    const comboId =
        form.dataset.shopLookId ||
        form.dataset.completeLookId;

    const role =
        form.dataset.shopLookRole ||
        form.dataset.completeLookRole ||
        "other";

    const source =
        form.dataset.shopLookSource ||
        form.dataset.completeLookSource ||
        "shop_this_look";

    const status =
        form.dataset.discountEnabled === "true" ||
        form.dataset.completeLookDiscountEnabled === "true";

    const discountPercent =
        form.dataset.discountPercent ||
        form.dataset.completeLookDiscountPercent ||
        "20";

    const endDate =
        form.dataset.endDate;

    /* UI */
    const icon = btn.querySelector(".btn-icon");
    const loading = btn.querySelector(".btn-loading");
    const text = btn.querySelector(".btn-text");

    btn.disabled = true;

    if (icon) icon.style.display = "none";
    if (loading) loading.style.display = "";
    if (text) text.textContent = "Adding...";

    try {
        const formData = new FormData(form);
        const properties = {};

        formData.forEach((value, key) => {
            if (!key.startsWith("properties[")) return;

            const name =
                key
                    .replace(/^properties\[/, "")
                    .replace(/\]$/, "");

            properties[name] = value;
        });

        /* COMPLETE THE LOOK PROPERTIES */

        if (comboId) {
            properties["_ctl_source"] = source;
            properties["_ctl_combo_id"] = comboId;
            properties["_ctl_role"] = role;

            if (status) {
                properties["_ctl_discount_percent"] =
                    discountPercent;
            }
        }

        properties["_ctl_status"] = status;
        properties["_ctl_end_date"] = endDate;


        /* PREORDER */
        let variantExtra = null;

        const variantExtraJson =
            form.querySelector(
                '[id^="variant-extra-"]'
            );

        if (variantExtraJson) {
            try {
                variantExtra =
                    JSON.parse(
                        variantExtraJson.textContent.trim()
                    );
            } catch (error) {
                console.error(
                    "[Shop The Look] Cannot parse variant-extra JSON",
                    error
                );
            }
        }

        const variantMeta =
            variantExtra?.[variantId];

        if (variantMeta) {
            const preorderProperties =
                window.KallesPreorder?.buildPreorderProperties({
                    isPreorder:
                        Boolean(variantMeta.isPreorder),
                    start:
                        variantMeta.dispatchStart,
                    end:
                        variantMeta.dispatchEnd
                }) || {};

            Object.assign(
                properties,
                preorderProperties
            );
        }

        /* PAYLOAD */
        const payload = {
            items: [{
                id: Number(variantId),
                quantity: 1,
                properties
            }]
        };

        /* ADD CART */
        const response = await fetch(
            "/cart/add.js",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify(payload)
            }
        );

        const data = await response.json();

        if (!response.ok) {
            throw new Error(
                data?.description ||
                data?.message ||
                "Unable to add product to cart"
            );
        }

        showAddedMessage(
            `${data?.items?.[0]?.product_title || "Product"} added to cart`
        );

        document.dispatchEvent(
            new CustomEvent("cart:refresh")
        );

    } catch (error) {
        console.error(
            "[Complete the look] ADD ERROR",
            error
        );

    } finally {
        btn.disabled = false;

        if (icon) icon.style.display = "";
        if (loading) loading.style.display = "none";
        if (text) text.textContent = "Add to cart";
    }
});

function showAddedMessage(message) {
    const toast = document.createElement("div");

    toast.className = "shop-look-toast";

    toast.innerHTML = `
        <svg width="20" height="20" viewBox="0 0 24 24">
            <path
                fill="#27ae60"
                d="M20.3 5.7a1 1 0 0 1 0 1.4l-10 10a1 1 0 0 1-1.4 0l-5-5a1 1 0 1 1 1.4-1.4L9.6 15l9.3-9.3a1 1 0 0 1 1.4 0z"
            />
        </svg>
        <span>${message}</span>
    `;

    document.body.appendChild(toast);

    requestAnimationFrame(() =>
        toast.classList.add("show")
    );

    setTimeout(() => {
        toast.classList.remove("show");

        setTimeout(() => toast.remove(), 300);
    }, 2500);
}


/* ============================================================
 * SLIDER
 * ============================================================ */

document.querySelectorAll(
    ".shop-look-slider, .complete-slider"
).forEach(slider => {
    const options =
        JSON.parse(slider.dataset.flickityt4sJs);

    const total =
        slider.querySelectorAll(
            ".t4s-col-item, .pr-complete-loop"
        ).length;

    const min =
        window.innerWidth >= 1024 ? 4 : 3;

    options.autoPlay =
        total >= min ? 2000 : false;

    slider.dataset.flickityt4sJs =
        JSON.stringify(options);
});


/* ============================================================
 * PRODUCT BUTTON COLOR
 * ============================================================ */

function getContrastColor(hex) {
    hex = hex.replace("#", "");

    if (hex.length === 3) {
        hex = hex
            .split("")
            .map(c => c + c)
            .join("");
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return (
        (r * 299 + g * 587 + b * 114) / 1000 > 160
            ? "#222222"
            : "#FFFFFF"
    );
}

function updateProductButtonColor() {
    const swatch =
        document.querySelector(
            ".is-t4s-style__color .t4s-swatch__item.is--selected"
        );

    if (!swatch) return;

    const form = swatch.closest("form");
    const button = form?.querySelector("[data-atc-form]");
    const value = swatch.dataset.value?.trim();

    if (!button || !value) return;

    const cls =
        "bg_color_" +
        value
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "");

    const temp = document.createElement("div");

    temp.className = cls;
    temp.style.display = "none";

    document.body.appendChild(temp);

    let color =
        getComputedStyle(temp)
            .getPropertyValue("--t4s-bg-color")
            .trim();

    temp.remove();

    const overrideColors = {
        white: "#F2E8D5",
        ivory: "#F3EFE6",
        cream: "#EEE8DD"
    };

    color =
        overrideColors[value.toLowerCase()] ||
        color ||
        "#000000";

    button.style.backgroundColor = color;
    button.style.borderColor = color;

    const textColor =
        getContrastColor(color);

    button.style.color = textColor;

    button.querySelectorAll("span, svg").forEach(el => {
        el.style.color = textColor;

        if (el.tagName === "svg") {
            el.style.fill = textColor;
        }
    });
}

function toggleCustomizeFields() {
    const wrapper =
        document.getElementById("customize-properties");

    const selected =
        document.querySelector(
            ".is-t4s-name__size .t4s-swatch__item.is--selected"
        );

    if (!wrapper || !selected) return;

    wrapper.style.display =
        selected.dataset.value
            ?.trim()
            .toLowerCase() === "customize"
            ? ""
            : "none";
}

document.addEventListener("click", e => {
    if (e.target.closest("[data-swatch-item]")) {
        setTimeout(() => {
            updateProductButtonColor();
            toggleCustomizeFields();
        }, 50);
    }

    document.querySelectorAll(".shop-look-form").forEach(form => {
        if (form.contains(e.target)) return;

        const wrapper =
            form.querySelector(".customize-properties");

        if (wrapper) {
            wrapper.style.display = "none";
        }
    });
});


/* ============================================================
 * GALLERY
 * ============================================================ */

(function () {
    const oldScrollIntoView =
        Element.prototype.scrollIntoView;

    Element.prototype.scrollIntoView = function (options) {
        if (
            this.closest("[data-main-media]") &&
            this.hasAttribute("data-main-slide")
        ) {
            console.log("Prevent gallery scroll");
            return;
        }

        return oldScrollIntoView.call(this, options);
    };
})();

document.addEventListener("change", e => {
    if (e.target.name !== "id") return;

    const option =
        e.target.selectedOptions[0];

    const mediaId =
        option?.dataset.mdid;

    const gallery =
        document.querySelector("[data-main-media]");

    if (!mediaId || !gallery) return;

    const slides = [
        ...gallery.querySelectorAll("[data-main-slide]")
    ];

    slides.forEach(slide =>
        slide.classList.remove("is-active")
    );

    const startIndex =
        slides.findIndex(
            slide =>
                slide.dataset.mediaId === mediaId
        );

    if (startIndex === -1) return;

    gallery.classList.toggle(
        "variant-gallery",
        slides[startIndex].classList.contains(
            "t4s-product__media-item--variant"
        )
    );

    for (
        let i = startIndex;
        i < slides.length;
        i++
    ) {
        if (
            i > startIndex &&
            slides[i].classList.contains(
                "t4s-product__media-item--variant"
            )
        ) {
            break;
        }

        slides[i].classList.add("is-active");
    }
});


/* ============================================================
 * PREORDER DISPATCH
 * ============================================================ */

(function () {
    function render() {
        const select =
            document.querySelector('select[name="id"]');

        const box =
            document.getElementById("preorder-dispatch");

        if (!select || !box) return;

        const option =
            select.selectedOptions[0];

        if (!option) return;

        const start =
            Number(option.dataset.start || 0);

        const end =
            Number(option.dataset.end || 0);

        const isPreorder =
            Number(option.dataset.inventoryquantity) <= 0 &&
            option.dataset.inventorypolicy === "continue";

        if (!isPreorder || (!start && !end)) {
            box.style.display = "none";
            box.innerHTML = "";
            return;
        }

        box.style.display = "";

        box.innerHTML = `
            <div class="preorder-shipping">
                MADE-TO-ORDER
                <svg viewBox="0 0 15 15" fill="none">
                    <path
                        d="M6.25501 7.69L6.31801 7.5L6.25501 7.31L5.76801 5.849L8.51901 7.5L5.76801 9.151L6.25501 7.69Z"
                        fill="currentColor"
                    />
                </svg>
                Shipping from
                <strong>
                    ${formatDate(start)} - ${formatDate(end)}
                </strong>
            </div>
        `;
    }

    document.addEventListener("DOMContentLoaded", render);

    document.addEventListener("change", e => {
        if (e.target.name === "id") render();
    });

    document.addEventListener("variant:change", render);
})();


/* ============================================================
 * COMPLETE LOOK DATE
 * ============================================================ */

const SHOP_TIMEZONE = "America/Phoenix";

function getShopLocalDate() {
    const parts =
        new Intl.DateTimeFormat("en-CA", {
            timeZone: SHOP_TIMEZONE,
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }).formatToParts(new Date());

    const values = {};

    parts.forEach(part => {
        if (part.type !== "literal") {
            values[part.type] = part.value;
        }
    });

    return `${values.year}-${values.month}-${values.day}`;
}

function isCompleteLookDateValid(
    currentDate,
    endDate
) {
    return Boolean(
        currentDate &&
        endDate &&
        currentDate < endDate
    );
}

function initCompleteLookCountdown() {
    document
        .querySelectorAll(".complete-look-countdown")
        .forEach(el => {
            if (
                el.dataset.countdownInitialized ===
                "true"
            ) {
                return;
            }

            el.dataset.countdownInitialized = "true";

            const endDateRaw =
                el.dataset.endDate;

            const daysEl =
                el.querySelector("[data-days-left]");

            if (!endDateRaw || !daysEl) return;

            const endDate =
                endDateRaw.substring(0, 10);

            const currentDate =
                getShopLocalDate();

            if (
                !isCompleteLookDateValid(
                    currentDate,
                    endDate
                )
            ) {
                el.remove();
                return;
            }

            const currentUTC =
                Date.UTC(
                    ...currentDate
                        .split("-")
                        .map(Number)
                        .map((value, index) =>
                            index === 1
                                ? value - 1
                                : value
                        )
                );

            const endUTC =
                Date.UTC(
                    ...endDate
                        .split("-")
                        .map(Number)
                        .map((value, index) =>
                            index === 1
                                ? value - 1
                                : value
                        )
                );

            const daysLeft =
                Math.floor(
                    (endUTC - currentUTC) /
                    86400000
                );

            if (daysLeft > 0) {
                daysEl.textContent = daysLeft;
            } else {
                el.remove();
            }
        });
}

function initCompleteLookDiscount() {
    document
        .querySelectorAll("[data-complete-the-look]")
        .forEach(container => {
            const titleElement =
                container.querySelector(
                    "[data-complete-look-title]"
                );

            const countdown =
                container.querySelector(
                    ".complete-look-countdown"
                );

            const looks =
                container.querySelectorAll(
                    "[data-look]"
                );

            if (!titleElement || !looks.length) {
                return;
            }

            const currentDate =
                getShopLocalDate();

            let activeLook = null;

            looks.forEach(look => {
                if (activeLook) return;

                const enabled =
                    look.dataset.discountEnabled ===
                    "true";

                const title =
                    look.dataset.discountTitle || "";

                const endDate =
                    look.dataset.endDate
                        ?.substring(0, 10);

                if (
                    enabled &&
                    endDate &&
                    currentDate < endDate
                ) {
                    activeLook = {
                        title,
                        endDate
                    };
                }
            });

            if (!activeLook) {
                if (countdown) {
                    countdown.hidden = true;
                }

                return;
            }

            if (activeLook.title) {
                titleElement.textContent =
                    activeLook.title;
            }

            if (!countdown) return;

            countdown.dataset.endDate =
                activeLook.endDate;

            countdown.hidden = false;

            const daysEl =
                countdown.querySelector(
                    "[data-days-left]"
                );

            if (!daysEl) return;

            const currentUTC =
                Date.UTC(
                    ...currentDate
                        .split("-")
                        .map(Number)
                        .map((value, index) =>
                            index === 1
                                ? value - 1
                                : value
                        )
                );

            const endUTC =
                Date.UTC(
                    ...activeLook.endDate
                        .split("-")
                        .map(Number)
                        .map((value, index) =>
                            index === 1
                                ? value - 1
                                : value
                        )
                );

            const daysLeft =
                Math.floor(
                    (endUTC - currentUTC) /
                    86400000
                );

            if (daysLeft > 0) {
                daysEl.textContent = daysLeft;
            } else {
                countdown.hidden = true;
            }
        });
}


/* ============================================================
 * TRACKING
 * ============================================================ */

document.querySelectorAll(".pr-complete-loop").forEach(
    element => {
        element.addEventListener("click", () => {
            window.gtag("event", "complete_the_look", {
                title: element.dataset.title,
                page_location: window.location.href
            });
        });
    }
);

document.querySelectorAll(".look-slide").forEach(
    element => {
        element.addEventListener("click", () => {
            window.gtag("event", "shop_the_look", {
                title: element.dataset.title,
                image: element.dataset.image,
                page_location: window.location.href
            });
        });
    }
);


/* ============================================================
 * DOM READY / LOAD
 * ============================================================ */

document.addEventListener("DOMContentLoaded", () => {
    updateProductButtonColor();
    toggleCustomizeFields();
    initCompleteLookCountdown();
    initCompleteLookDiscount();
});

window.addEventListener("load", () => {
    document
        .querySelectorAll(".complete-slider")
        .forEach(slider => {
            const flkty = Flickity.data(slider);
            flkty?.resize();
        });
});